export default "__VITE_ASSET__DdKFE8YH__"